
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getVariousTagsList } from '@/api/allTags';

@Component({
  name: 'faultDialog'
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogVisibility!: Boolean;

   @Prop({
     type: Number,
     default: 0
   })
  enterType!: any;
  @Prop({
    type: String,
    default: ''
  })
  contentValue!: any;

  private title:string='';
  private content:string=''
  private remarkType:any={};
  private remarkTypeList:any=[];
  created() {
    this.content = this.contentValue;
    switch (this.enterType) {
      case 0:
        this.title = '备注';
        break;
      case 1:
        this.title = '自定义1';
        break;
      case 2:
        this.title = '自定义2';
        break;
    }
  }
  private getVariousTagsList() {
    let VariousTagsParam: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: 1,
      size: 9999,
      type: 4
    };
    getVariousTagsList(VariousTagsParam).then(res => {
      if (res.data) {
        this.remarkTypeList = res.data.list;
      } else {
        this.remarkTypeList = [];
      }
    }).catch((err: any) => {
      let msg = err.msg;
    });
  }
  private close() {
    this.$emit('close', false);
  }
  private comfirmHandle() {
    if (this.enterType === 0) {
      this.$emit('comfirmHandle', this.content, this.remarkType);
    } else {
      this.$emit('comfirmHandle', this.content);
    }
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
